import { handleApiCall } from "../HandleApi";
import { handleApiCall as handleApiCallTS, handleBifrostApiCall, handleInSecureApiCall } from "../HandleApiTs";
import { getPartnerIds, associateJhhPartner, getPartnerDiscovery, getCorporateServices } from "../../config.json";
import { _isBifrostTokenCallRequired } from "../BifrostToken";
import { _getItemFromLocal } from "../LocalKeys";

export const _getPartnerIds = (dataObj: {}) =>
  handleApiCallTS(
    {
      url: getPartnerIds,
      method: "post",
      dataObj: dataObj,
      requestBody: { type: Object, encryption: true, queryString: true },
      responseBody: { decryption: true },
    },
    true,
    true
  );

export const _associateJhhPartnerApiCall = (dataObj: {}) =>
  handleApiCall(
    {
      url: associateJhhPartner,
      method: "post",
      dataObj: dataObj,
      requestBody: { type: Object, encryption: true, queryString: true },
      responseBody: { decryption: true },
    },
    true,
    true
  );

export const _getPartnerDiscoveryApiCall = (dataObj:{}) => handleApiCall(
    {
      url:getPartnerDiscovery,
      method:"post",
      dataObj:dataObj,
      headers:{"Content-Type": "application/x-www-form-urlencoded"},
      requestBody:{type:Object,encryption:true,queryString:true},
      responseBody: { decryption: true },
    },
    true
  );

export const _getCorporateServicesApiCall = async(dataObj: {}) => {
  return handleBifrostApiCall(
    {
      url: getCorporateServices,
      method: "post",
      dataObj: dataObj,
      requestBody: { type: Object, encryption: true,queryString: false },
      responseBody: { decryption: true, keyParsing: true },
      headers:{"Authorization":`Bearer ${_getItemFromLocal("_bt")}`}
    },
    _isBifrostTokenCallRequired(),
  );
};

export const _getServicesJsonFromS3ApiCall = (path: string) => {
  return handleInSecureApiCall({
    // url: `${"TODO"}${path}`,
    url: `https://d2se267tirxpef.cloudfront.net/test/exclusiveServicesMap.json`, // TODO current test url for bucket, replace once bucket issue resolved
    method: "get"
  })
}